import Tippy from '@tippyjs/react';

import { cn } from 'lib/helpers/utility';
import useCopy from 'lib/hooks/useCopy';

import Icon from 'components/shared/Icon/Icon';

import hasMeaningfulContent from '../lib/hasMeaningfulContent';

const CopyButton = ({ value, disabled, getText, className }) => {
  const { copyToClipboard } = useCopy();

  if (!disabled || !hasMeaningfulContent(value)) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    const text = typeof getText === 'function' ? getText() : String(value ?? '');
    if (text) copyToClipboard(text);
  };

  return (
    <Tippy content="Copy" className="tippy-dark">
      <button
        type="button"
        aria-label="Copy content to clipboard"
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={handleClick}
        className={cn(
          'pointer-events-auto absolute right-1.5 top-1.5 z-50 flex !cursor-pointer items-center justify-center rounded border-none bg-transparent p-1.5 text-neutral-500 transition hover:bg-neutral-200 hover:text-neutral-700',
          className
        )}>
        <Icon icon="copy-mono" color="neutral" />
      </button>
    </Tippy>
  );
};

export default CopyButton;
